import { validateAdminNamespace } from './validate-admin-namespace.js'

export function validateAdminDashboardPath(value: string): string {
  const input = value.trim()
  const segment = input.startsWith('/') ? input.slice(1) : input

  if (input.startsWith('/') && input !== `/${segment}`) {
    throw new Error(
      'Dashboard path must be one lowercase kebab-case segment starting with a letter, for example "/admin" or "/admin-panel".'
    )
  }

  try {
    return validateAdminNamespace(segment)
  } catch {
    throw new Error(
      'Dashboard path must be one lowercase kebab-case segment starting with a letter, for example "/admin" or "/admin-panel".'
    )
  }
}
